<template>
	<v-img
		src="../assets/images/mockup-pt1.png"
		class="mock-up"
		style="position: relative"
	>
		<div class="header text-center pt-8 pt-sm-9">
			Tella Tutor<br />
			<span class="primary--text"
				>{{ $t('main.img.title') }} 16:00 - 16:25</span
			>
		</div>
		<div class="chat-wrap d-flex align-end justify-end">
			<div class="time mr-1">{{ $t('chat-time.pm') }} 16:10</div>
			<div class="chat student">
				<p>Can you borrow me some money? My credit card limit is over.</p>
			</div>
		</div>
		<div class="chat-wrap d-flex align-end mb-0">
			<img
				width="25"
				class="mr-1"
				src="@/assets/images/profile-tutor.png"
				alt=""
			/>
			<div class="tutor-name">Tella Tutor</div>
		</div>
		<div class="chat-wrap d-flex align-end justify-start pt-1">
			<div class="chat tutor" style="max-width 100%">
				<div class="edit-tag">
					{{ $t('main.img.tag.editing') }}
					<img src="@/assets/images/edit-icon.png" alt="교정" />
				</div>
				<p class="mt-1">
					Can you <span class="edit--text font-weight-bold">*lend</span> me some
					money? <br />
					I
					<span class="edit--text font-weight-bold"
						>*reached the credit limit.</span
					>
				</p>
			</div>
		</div>
		<div class="chat-wrap d-flex align-end justify-start pt-3">
			<div class="chat tutor" style="max-width: 95%">
				<div class="edit-tag">
					{{ $t('main.img.tag.native') }}
					<img
						width="13"
						style="margin-bottom: -2px"
						src="@/assets/images/thumbs-up-icon.png"
						alt="교정"
					/>
				</div>
				<p class="mt-1">
					Can you spot me? <br />
					I maxed out my credit card.
				</p>
			</div>
			<div class="time ml-1 text-left">{{ $t('chat-time.pm') }} 16:12</div>
		</div>
	</v-img>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.mock-up {
	width: 300px;
	margin: 0 auto;
}

.header {
	font-size: 10px;
	font-weight: normal;
	font-stretch: normal;
	font-style: normal;
	line-height: normal;
	letter-spacing: normal;
	text-align: center;
	color: #888;
}
.chat-wrap {
	padding: 25px 20px 0 20px;
}
.chat-wrap .time {
	font-family: Pretendard;
	font-size: 7.2px;
	font-weight: 500;
	font-stretch: normal;
	font-style: normal;
	line-height: normal;
	letter-spacing: -0.36px;
	color: #b6b6b6;
	width: 15%;
}
// @media screen and (max-width: 600px) {
// 	.chat-wrap .time {
// 		font-size: 6px;
// 		width: ;
// 	}
// }
.chat {
	text-align: left;
	p {
		margin-bottom: 0;
	}
}
.chat.student {
	padding: 10px 15px 10.2px 14px;
	object-fit: contain;
	background-color: #4a7cfb;
	border-top-left-radius: 15px;
	border-bottom-left-radius: 15px;
	border-bottom-right-radius: 15px;
	width: 65%;

	p {
		font-size: 10.7px;
		font-weight: 500;
		font-stretch: normal;
		font-style: normal;
		line-height: 1.45;
		letter-spacing: -0.25px;
		color: #fff;
	}
}
.chat.tutor {
	padding: 12px 12px 12px 12px;
	box-shadow: 2px 5px 24px 0 rgba(33, 51, 82, 0.18);
	background-color: #fff;
	border-bottom-left-radius: 15px;
	border-bottom-right-radius: 15px;
	border-top-right-radius: 15px;

	p {
		font-size: 14.4px;
		font-weight: normal;
		font-stretch: normal;
		font-style: normal;
		line-height: 1.33;
		letter-spacing: -0.25px;
		color: #1a1a1a;
		.edit--text {
			color: #15c39a;
		}
	}
	@media screen and (max-width: 600px) {
		.p {
			font-size: 12px;
			font-weight: 600;
			font-stretch: normal;
			font-style: normal;
			line-height: 1.33;
			letter-spacing: -0.21px;
		}
	}
}

.edit-tag {
	border-radius: 12px;
	background-color: #15c39a;
	font-size: 12px;
	font-weight: bold;
	font-stretch: normal;
	font-style: normal;
	line-height: 1.65;
	letter-spacing: -0.21px;
	color: #fff;
	padding: 5px 7px 2.8px 9px;
	display: inline;
}

.tutor-name {
	font-size: 11.9px;
	font-weight: normal;
	font-stretch: normal;
	font-style: normal;
	line-height: 1.46;
	letter-spacing: -0.21px;
	color: #666;
}
</style>
